import { createContext } from 'react';
import { decorate, observable, action, toJS } from 'mobx';

import * as fn from '../utilities/_functions';
import api from '../api';

export class ReferralUserExamDatasetGroupUpdate {
    id = null;
    data = {
        name: null,
        subject: null,
        bodyHtml: null,
        descriptionHtml: null,
        examDatasetIds: [],
        examPublishedTemplateId: null,
    };
    isSaving = false;
    hasUnsavedChanges = false;

    cancelReferralUserExamDatasetGroupGet = null;
    cancelReferralUserExamDatasetGroupUpdate = null;

    initialize = (options) => {
        const defaultOptions = {
            id: null,
            subject: null,
            bodyHtml: null,
            examPublishedTemplateId: null,
            examDatasetIds: [],
        };
        const Options = { ...defaultOptions, ...options };
        const that = this;

        that.clear();
        that.id = Options.id;

        return new Promise((resolve, reject) => {
            if (Options.id) {
                api.ReferralUserExamDatasetGroups.get(Options.id, (c) => { that.cancelReferralUserExamDatasetGroupGet = c })
                    .then(({ data }) => {
                        if (data) {
                            that.data.name = data.name;
                            that.data.subject = data.subject;
                            that.data.bodyHtml = data.bodyHtml;
                            that.data.examPublishedTemplateId = data.examPublishedTemplateId;
                            that.data.examDatasetIds = data.examDatasetIds;
                        }
                        resolve();
                    })
            }
            else {
                that.data.subject = Options.subject;
                that.data.bodyHtml = Options.bodyHtml;
                that.data.examPublishedTemplateId = Options.examPublishedTemplateId;
                that.data.examDatasetIds = Options.examDatasetIds;
                that.hasUnsavedChanges = true;
                resolve();
            }
        })
    }

    save = (notify) => {
        const that = this;

        if (!!notify) {
            this.isSaving = true;
        }

        return new Promise((resolve, reject) => {
            let option = toJS(that.data);

            if (that.hasUnsavedChanges) {
                if (that.id) {
                    api.ReferralUserExamDatasetGroups.update(that.id, option, (c) => { that.cancelReferralUserExamDatasetGroupUpdate = c })
                        .then(() => {
                            that.hasUnsavedChanges = false;
                            option.id = that.id;
                            resolve(option);
                        })
                        .catch((error) => {
                            reject(error);
                        })
                        .finally(() => {
                            that.isSaving = false;
                        })
                }
                else {
                    api.ReferralUserExamDatasetGroups.create(option, (c) => { that.cancelReferralUserExamDatasetGroupUpdate = c })
                        .then(({ data }) => {
                            that.id = data.id;
                            that.hasUnsavedChanges = false;
                            option.id = data.id;
                            resolve(option);
                        })
                        .catch((error) => {
                            reject(error);
                        })
                        .finally(() => {
                            that.isSaving = false;
                        })
                }
            } else {
                that.hasUnsavedChanges = false;
                that.isSaving = false;
            }
        })
    }

    delete = (notify) => {
        const that = this;

        if (!!notify) {
            this.isSaving = true;
        }

        return new Promise((resolve, reject) => {
            if (that.id) {
                api.ReferralUserExamDatasetGroups.delete(that.id, (c) => { that.cancelReferralUserExamDatasetGroupUpdate = c })
                    .then(() => {
                        that.hasUnsavedChanges = false;
                        resolve();
                    })
                    .catch((error) => {
                        reject(error);
                    })
                    .finally(() => {
                        that.isSaving = false;
                    })
            }
        })
    }

    clear = () => {
        this.id = null;
        this.data.name = null;
        this.data.subject = null;
        this.data.bodyHtml = null;
        this.data.descriptionHtml = null;
        this.data.examDatasetIds.clear();
        this.data.examPublishedTemplateId = null;
        this.isSaving = false;
        this.hasUnsavedChanges = false;

        if (fn.isFunction(this.cancelReferralUserExamDatasetGroupGet)) {
            this.cancelReferralUserExamDatasetGroupGet();
            this.cancelReferralUserExamDatasetGroupGet = null;
        }

        if (fn.isFunction(this.cancelReferralUserExamDatasetGroupUpdate)) {
            this.cancelReferralUserExamDatasetGroupUpdate();
            this.cancelReferralUserExamDatasetGroupUpdate = null;
        }
    }
}

decorate(ReferralUserExamDatasetGroupUpdate, {
    id: observable,
    data: observable.deep,
    isSaving: observable,
    initialize: action,
    hasUnsavedChanges: observable,
    save: action,
    delete: action,
    clear: action,
})

export default createContext(new ReferralUserExamDatasetGroupUpdate());